// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_page_wrapper___TWPk"};